import React, { Component } from "react";
import { FormattedMessage } from "react-intl";

import ButtonAppStore from "../assets/button-app-store.png";
import ButtonGooglePlay from "../assets/button-google-play.png";

import constants from "../../common/constants";
import BrandHelper from "../brand/brand-helper";

class SignUpFinished extends Component {
  render() {
    const brand = BrandHelper.getMyDomainObject();
    const downloadLinks = BrandHelper.getDownloadLinks(brand);

    if (brand.name === "healo")
      return (
        <div className="modal finished">
          <div>
            <div className="finished__title">
              <FormattedMessage id="sign-up.finish_main" />
            </div>
            <p>
              <FormattedMessage id="sign-up.finish" />
            </p>
            <div className="apps">
              <a href={downloadLinks.ios}>
                <img src={ButtonAppStore} alt="Link to app store" />
              </a>
              <a href={downloadLinks.android}>
                <img src={ButtonGooglePlay} alt="Link to google play" />
              </a>
            </div>
          </div>
        </div>
      );
    else
      return (
        <div className="modal finished">
          <div>
            <div className="finished__title">
              <FormattedMessage id="sign-up.finish_main" />
            </div>
            <p>
              <FormattedMessage id="sign-up-clinic.finish" />
            </p>
            <p>
              <FormattedMessage id="sign-up-clinic.finish_2" />
            </p>
            <p>
              <FormattedMessage id="sign-up-clinic.finish_3" />
            </p>
            <div className="apps clinic">
              <a href={downloadLinks.ios}>
                <img src={ButtonAppStore} alt="Link to app store" />
              </a>
              <a href={downloadLinks.android}>
                <img src={ButtonGooglePlay} alt="Link to google play" />
              </a>
            </div>
          </div>
        </div>
      );
  }
}

export default SignUpFinished;



// WEBPACK FOOTER //
// ./src/modules/auth/sign-up-finished.js